import React , { useState }from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import '../styles/Navigation.css';
import Logo from '../images/logo-GareTroo.jpg';
import ImpPlanning from '../pages/Admin/ImpPlanning';

const Navigation = ({ onLogout, onViewChange, token, droit, currentView }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleMenuItemClick = () => {
      setMenuOpen(false);
    };

    const handleDropdownClick = (action) => {
      if (action) action();
      setDropdownOpen(false);
      setMenuOpen(false);
    };

    const handleViewNavigation = (view) => {
      if (location.pathname !== '/EspaceBenevoles') {
        navigate('/EspaceBenevoles');
      }
      onViewChange(view);
      setDropdownOpen(false);
      setMenuOpen(false);
    };

    return (
                   
        <div className="navigation">
                <a href="./Accueil"> <img src={Logo} className="imgLogo" alt="Gare de Troo" /></a>
                <input id="menu-toggle" type="checkbox" checked={menuOpen} onChange={() => setMenuOpen(!menuOpen)}  />
                <label className='menu-button-container' htmlFor="menu-toggle">
                    <div style={{ fontWeight: 'bold', color: 'white',marginRight : '95px'}}>Menu</div>
                    <div className='menu-button'></div>
                </label>


                {/* <a href="./Accueil"> <img src={Logo} className="imgLogo" alt="Gare de Troo" /></a> */}
            <ul className="menu">
                <li>
                    <NavLink to="/Accueil" className = "menuLinkButton" onClick={handleMenuItemClick}>Accueil</NavLink> 
                </li>
                <li>
                    <NavLink to="/Actualites" className = "menuLinkButton" onClick={handleMenuItemClick} >Actualités</NavLink> 
                </li>
                <li>
                    <NavLink to="/Boutique" className = "menuLinkButton" onClick={handleMenuItemClick}>Boutique</NavLink> 
                </li>
                <li>
                    <NavLink to="/Contact" className = "menuLinkButton" onClick={handleMenuItemClick}>Contact</NavLink> 
                </li>
                <li>
                    <NavLink to="/Horaires" className = "menuLinkButton" onClick={handleMenuItemClick}>Horaires</NavLink> 
                </li>
                <li>
                    <NavLink to="/Partenaires" className = "menuLinkButton" onClick={handleMenuItemClick}>Partenaires</NavLink> 
                </li>
                <li className="espace-benevoles-menu-item">
                  <div className="dropdown-container">
                    <button 
                      className="menuLinkButton dropdown-button"
                      onClick={() => setDropdownOpen(!dropdownOpen)}
                    >
                      Espace Bénévoles ▼
                    </button>
                    <div className={`dropdown-menu ${dropdownOpen ? 'open' : ''}`}>
                      {!token ? (
                        <NavLink 
                          to="/EspaceBenevoles" 
                          className="dropdown-item"
                          onClick={() => handleDropdownClick()}
                        >
                          Se connecter
                        </NavLink>
                      ) : (
                        <>
                          <button 
                            className={`dropdown-item ${currentView === 'planning' ? 'active' : ''}`}
                            onClick={() => handleViewNavigation('planning')}
                          >
                            📅 Planning
                          </button>
                          {(droit === 'sadmin' || droit === 'admin') && (
                            <button 
                              className={`dropdown-item ${currentView === 'admin' ? 'active' : ''}`}
                              onClick={() => handleViewNavigation('admin')}
                            >
                              🔧 Espace Admin
                            </button>
                          )}
                          <div className="dropdown-divider"></div>
                          <div className="dropdown-item-export">
                            <ImpPlanning token={token} />
                          </div>
                          <div className="dropdown-divider"></div>
                          {onLogout && (
                            <button 
                              className="dropdown-item dropdown-item-danger"
                              onClick={() => handleDropdownClick(onLogout)}
                            >
                              🚪 Déconnexion
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </li>
            </ul>
            <div className="espace-benevoles-header">
                <div className="dropdown-container">
                  <button 
                    className="menuLinkButton dropdown-button"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                  >
                    Espace Bénévoles ▼
                  </button>
                  <div className={`dropdown-menu ${dropdownOpen ? 'open' : ''}`}>
                    {!token ? (
                      <NavLink 
                        to="/EspaceBenevoles" 
                        className="dropdown-item"
                        onClick={() => handleDropdownClick()}
                      >
                        Se connecter
                      </NavLink>
                    ) : (
                      <>
                        <button 
                          className={`dropdown-item ${currentView === 'planning' ? 'active' : ''}`}
                          onClick={() => handleViewNavigation('planning')}
                        >
                          📅 Planning
                        </button>
                        {(droit === 'sadmin' || droit === 'admin') && (
                          <button 
                            className={`dropdown-item ${currentView === 'admin' ? 'active' : ''}`}
                            onClick={() => handleViewNavigation('admin')}
                          >
                            🔧 Espace Admin
                          </button>
                        )}
                        <div className="dropdown-divider"></div>
                        <div className="dropdown-item-export">
                          <ImpPlanning token={token} />
                        </div>
                        <div className="dropdown-divider"></div>
                        {onLogout && (
                          <button 
                            className="dropdown-item dropdown-item-danger"
                            onClick={() => handleDropdownClick(onLogout)}
                          >
                            🚪 Déconnexion
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
            </div>
        </div>

    );
};

export default Navigation;